let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
console.log(items)
items.forEach(item => {
item.addEventListener("mouseover", () => {
item.setAttribute("open", true);
item.querySelector("ul").addEventListener("mouseleave", () => {
item.removeAttribute("open");
});
item.addEventListener("mouseleave", () => {
item.removeAttribute("open");
});
});

});
jQuery(document).ready(function($){
  $('#bannerSlider').owlCarousel({
    loop: true,
    margin: 20,
    nav: false,
    autoplayTimeout:10000,
    autoplay:true,
    animateIn: 'fadeIn',
    animateOut: 'fadeOut',
    responsive: {
        0: {
            items: 1
        },
        600: {
            items: 1
        },
        768: {
            items: 1
        },
        1000: {
          items: 1
      },
        1366: {
            items: 1
        }
    }
    });
  
});